export const root_project_folder_id = "_root_project_folder_"
